import { createContext, useContext, useEffect, useState } from "react";

export const VARIANTS = [
  {
    id: "editorial",
    name: "The Gallery Archive",
    tag: "Light · Editorial",
    swatch: "#8A7961",
    bg: "#F5F3EF",
  },
  {
    id: "vault",
    name: "Midnight Vault",
    tag: "Dark · Premium",
    swatch: "#C5A059",
    bg: "#0A0A0A",
  },
  {
    id: "swiss",
    name: "Swiss Brutalist",
    tag: "Bold · Minimal",
    swatch: "#DC2626",
    bg: "#FFFFFF",
  },
];

const VariantContext = createContext(null);

export const VariantProvider = ({ children }) => {
  const [variant, setVariant] = useState(
    () => localStorage.getItem("gw-variant") || "editorial"
  );

  useEffect(() => {
    localStorage.setItem("gw-variant", variant);
  }, [variant]);

  return (
    <VariantContext.Provider value={{ variant, setVariant }}>
      {children}
    </VariantContext.Provider>
  );
};

export const useVariant = () => {
  const ctx = useContext(VariantContext);
  return { ...ctx, variant: "vault" };
};
